import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import dummy from "./dummy.jpg";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./beautyabout.css";
export default function AboutPage() {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <Navbar />

      {/* ================= HERO SECTION ================= */}
      <section className="hero-section">
        <div className="hero-content slide-up">
          <h1>Empowering Beauty, Comfort & Confidence</h1>
        </div>
      </section>

      {/* ================= OUR STORY ================= */}
      <section className="py-5 bg-theme text-center">
        <div className="container">
          <h2 className="fw-bold slide-up mb-4">Our Story</h2>
          <p className="lead slide-up">
            We started with a simple idea – bringing beauty and wellness to your doorstep.
            With years of experience and passion for empowering women, our home salon
            services are built to make every woman feel comfortable, confident, and cared for.
          </p>
        </div>
      </section>

      {/* ================= TEAM ================= */}
      <section className="py-5 text-center bg-white">
        <div className="container">
          <h2 className="fw-bold slide-up mb-4">Meet Our Team</h2>

          <div className="row g-4 justify-content-center">
            {[
              { name: "Priya Sharma", role: "Founder & CEO" },
              { name: "Neha Verma", role: "Head Beautician" },
              { name: "Sonal Das", role: "Operations Manager" },
            ].map((member, index) => (
              <div className="col-sm-6 col-md-4" key={index}>
                <div className="card shadow-sm border-0 team-card h-100">
                  <img src={dummy} className="card-img-top" alt={member.name} />
                  <div className="card-body">
                    <h5>{member.name}</h5>
                    <p className="text-muted">{member.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= WHY CHOOSE US ================= */}
      <section className="py-5 text-center bg-theme">
        <div className="container">
          <h2 className="mb-4 fw-bold slide-up">Why Choose Us?</h2>

          <div className="row g-4">
            {[
              { icon: "bi-shield-check", title: "Trust" },
              { icon: "bi-lightning-charge", title: "Innovation" },
              { icon: "bi-star-fill", title: "Quality" },
            ].map((item, index) => (
              <div key={index} className="col-md-4">
                <div className="p-4 border rounded shadow-sm bg-white fade-in h-100">
                  <i className={`bi ${item.icon} fs-1 text-primary`}></i>
                  <h5 className="mt-3">{item.title}</h5>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="py-5 text-center bg-white">
        <div className="container">
          <h2 className="fw-bold slide-up">
            Ready to Experience the Difference?
          </h2>
          <p className="lead fade-in-delay">
            Book your premium home salon session today.
          </p>

          <button
            onClick={() => navigate("/products")}
            className="btn custom-btn btn-lg mt-3"
          >
            Explore Services
          </button>
        </div>
      </section>

      <Footer />
    </>
  );
}